import $ from 'jQuery';


import submitForm from './modules/submit-form';
import cookies from './modules/cookies';
import CarouselSlider from './modules/carousel-slider';
import Formstyler from './modules/formstyler';
import Header from './modules/header';
import ScrollLink from './modules/scroll-link';
import Tabs from './modules/tabs';
import Preloader from './modules/preloader';
import Animation from './modules/animation';
import Listing from './modules/listing';
import jakte from './modules/jakte';
import vars from '../../../vars.js';


import 'styles/less/application';


$(document).ready(() => {
  $(this).scrollTop(0);
  submitForm.init();
  cookies.init();
  CarouselSlider.init();
  Formstyler.init();
  Header.init();
  ScrollLink.init();
  Tabs.init();
  Preloader.init();
  Animation.init();
  Listing.init();
  if (vars.slug && ! vars.isDevelopment) {
    jakte.init();
  }
});



// WEBPACK FOOTER //
// ./src/static/js/main.js